/**
 * Meanbook Note - UI Helper Functions (Toast, Confirm, Formatting, HTML Escaping)
 */

let toastTimeoutId = null;

export function escapeHTML(str) {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function showToast(message, type = 'success') {
  let toast = document.getElementById("app-toast");
  if (!toast) {
    toast = document.createElement("div");
    toast.id = "app-toast";
    toast.className = "toast";
    document.body.appendChild(toast);
  }

  if (toastTimeoutId) {
    clearTimeout(toastTimeoutId);
  }

  const icon = type === 'success' ? 'check-circle' : 'alert-circle';
  toast.innerHTML = `<i data-lucide="${icon}"></i> <span>${escapeHTML(message)}</span>`;

  if (window.lucide) {
    window.lucide.createIcons();
  }

  toast.classList.add("show");
  toastTimeoutId = setTimeout(() => {
    toast.classList.remove("show");
    toastTimeoutId = null;
  }, 2200);
}

export function showConfirm(title, message, onConfirm) {
  const modal = document.getElementById("confirm-modal");
  const titleEl = modal ? modal.querySelector(".custom-modal-title") : null;
  const msgEl = document.getElementById("confirm-modal-message");
  const btnCancel = document.getElementById("btn-confirm-cancel");
  const btnOk = document.getElementById("btn-confirm-ok");

  if (!modal || !msgEl || !btnCancel || !btnOk) {
    try {
      if (window.confirm(message)) {
        onConfirm();
      }
    } catch (e) {
      console.error("Native confirm failed, executing fallback directly:", e);
      onConfirm();
    }
    return;
  }

  if (titleEl) titleEl.innerText = title;
  msgEl.innerText = message;
  modal.style.display = "flex";

  if (window.lucide) window.lucide.createIcons();

  const newBtnOk = btnOk.cloneNode(true);
  btnOk.parentNode.replaceChild(newBtnOk, btnOk);

  const newBtnCancel = btnCancel.cloneNode(true);
  btnCancel.parentNode.replaceChild(newBtnCancel, btnCancel);

  newBtnCancel.addEventListener("click", () => {
    modal.style.display = "none";
  });

  newBtnOk.addEventListener("click", () => {
    modal.style.display = "none";
    if (typeof onConfirm === "function") {
      onConfirm();
    }
  });
}

export function formatThaiDate(timestamp) {
  if (!timestamp) return "เพิ่งอัปเดต";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleDateString("th-TH", {
    day: "numeric",
    month: "short",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  }) + " น.";
}

export function updateMobileTabLabels() {
  const tabEditor = document.getElementById("tab-editor");
  if (tabEditor) {
    const label = tabEditor.querySelector("span");
    let icon = tabEditor.querySelector("i, svg");

    if (icon && icon.tagName.toLowerCase() === "svg") {
      const newIcon = document.createElement("i");
      newIcon.setAttribute("data-lucide", icon.getAttribute("data-lucide"));
      icon.parentNode.replaceChild(newIcon, icon);
      icon = newIcon;
    }

    if (window.innerWidth <= 600) {
      if (label && label.textContent !== "ค้นหา") label.textContent = "ค้นหา";
      if (icon && icon.getAttribute("data-lucide") !== "search") {
        icon.setAttribute("data-lucide", "search");
      }
    } else {
      if (label && label.textContent !== "ออเดอร์บอร์ด") label.textContent = "ออเดอร์บอร์ด";
      if (icon && icon.getAttribute("data-lucide") !== "clipboard-list") {
        icon.setAttribute("data-lucide", "clipboard-list");
      }
    }
    if (window.lucide) window.lucide.createIcons();
  }
}

export function renderFieldRow(label, value, isPhone = false, isMultiline = false) {
  if (!value) return "";
  const safeValue = escapeHTML(value);
  return `
    <div class="address-field-row ${isMultiline ? 'multiline' : ''}">
      <span class="field-label">${label}</span>
      <span class="field-value ${isPhone ? 'highlight-phone' : ''}">${safeValue}</span>
      <button class="btn-copy-field" data-copy-val="${safeValue}" title="คัดลอกช่องนี้">
        <i data-lucide="copy"></i>
      </button>
    </div>
  `;
}
